export function round(number, places) {
  const decimals = (number + '').split('.')[1];
  if (decimals && decimals.length > places) {
    return number.toFixed(places);
  } else {
    return number;
  }
}
